import api from "./api";
import endpoints from "./endpoints";

export default {
  simpleSearch: async function (searchLanguage, resultLanguage, searchTerm, pagesize, page) {
    const response = await api.get(endpoints.simpleSearch.get, {
      params: { searchLanguage, resultLanguage, searchTerm, pagesize, page }
    });
    return response.data;
  },
  searchInCatalog: async function (catalogId, keywords, language) {
    const response = await api.get(endpoints.simpleSearch.catalog, {
      params: { catalogId, keywords, language }
    });
    return response.data;
  }
};
